import React from 'react'
import { Radio, Button } from 'antd'
import styled from 'styled-components'

interface ModeSelectorProps {
  value: 'year' | 'month' | 'week' | 'day'
  onChange: (value: 'year' | 'month' | 'week' | 'day') => void
  showTimetableToggle?: boolean
  isTimeTableViewMode?: boolean
  onTimetableToggle?: () => void
  hideToggleOnMobile?: boolean
}

const Container = styled.div`
  background: #fafafa;
  border-radius: 6px;
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`

const ModesWrapper = styled.div`
  flex: 1;
`

const TimetableButton = styled(Button)<{ $hideOnMobile?: boolean }>`
  ${props => props.$hideOnMobile && `
    @media (max-width: 768px) {
      display: none;
    }
  `}
`

export const ModeSelector: React.FC<ModeSelectorProps> = ({ 
  value, 
  onChange, 
  showTimetableToggle,
  isTimeTableViewMode,
  onTimetableToggle,
  hideToggleOnMobile = false
}) => {
  return (
    <Container>
      <ModesWrapper>
        <Radio.Group
          value={value}
          onChange={(e) => onChange(e.target.value)}
          buttonStyle='solid'
          size='small'
        >
          <Radio.Button value='day'>День</Radio.Button>
          <Radio.Button value='week'>Неделя</Radio.Button>
          <Radio.Button value='month'>Месяц</Radio.Button>
          <Radio.Button value='year'>Год</Radio.Button>
        </Radio.Group>
      </ModesWrapper>
      {showTimetableToggle && onTimetableToggle && (
        <TimetableButton 
          size='small' 
          onClick={onTimetableToggle}
          $hideOnMobile={hideToggleOnMobile}
        >
          {isTimeTableViewMode ? 'Скрыть расписание' : 'Показать расписание'}
        </TimetableButton>
      )}
    </Container>
  )
}

